import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import Slider from 'react-slick'
import Link from '../utils/link'
import Fade from 'react-reveal/Fade'

const NewsFeature = ({ title, items }) => {
  return (
    <section className='news-feature'>
      {title && (
        <div className='news-feature__inner'>
          <Fade bottom distance='40px'>
            <h2>{title}</h2>
          </Fade>
        </div>
      )}
      <div className='news-feature__slider'>
        <Slider {...{
          dots: false,
          arrows: true,
          speed: 500,
          slidesToShow: 5.2,
          infinite: false,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1800,
              settings: {
                slidesToShow: 4.7,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 1380,
              settings: {
                slidesToShow: 3.8,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 1100,
              settings: {
                slidesToShow: 3.2,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 1000,
              settings: {
                slidesToShow: 2.8,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 760,
              settings: {
                slidesToShow: 2.2,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 680,
              settings: {
                slidesToShow: 1.8,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 481,
              settings: {
                slidesToShow: 1.4,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 410,
              settings: {
                slidesToShow: 1.2,
                slidesToScroll: 1,
              }
            },
          ]
        }}>
          {items.map((item, i) => (
            <Link to={item.url} key={i} className='news-feature__item'>
              <Fade bottom distance='40px'>
                <div className='news-feature__item-content'>
                  <GatsbyImage image={item.image.localFile?.childImageSharp?.gatsbyImageData} alt={item.title} />
                  <h3>{item.title}</h3>
                  {item.label && <p>{item.label}</p>}
                </div>
              </Fade>
            </Link>
          ))}
        </Slider>
      </div>
    </section>
  )
}

export default NewsFeature